import { DATA_STORE_KEYS } from './dataStoreKeys';

// ----------- STORE TYPES -----------
export const DATA_STORE_LOCAL_STORAGE_KEYS = [
    DATA_STORE_KEYS.USER,
    DATA_STORE_KEYS.USER_DATA,
    DATA_STORE_KEYS.IS_LOGGEDIN,
    DATA_STORE_KEYS.CISCO_AUTH_TOKEN,
    DATA_STORE_KEYS.DIRECTION,
    DATA_STORE_KEYS.USER_EMPLOYEE,
    DATA_STORE_KEYS.USER_CURRENT_ROLE,
];

export const DATA_STORE_SESSION_STORAGE_KEYS = [
    DATA_STORE_KEYS.UTM_MEDIUM,
    DATA_STORE_KEYS.UTM_SOURCE,
    DATA_STORE_KEYS.IS_SESSION_INIT,
];

export const DATA_STORE_COOKIE_STORAGE_KEYS = [
    DATA_STORE_KEYS.GRC_CHALLENGE,
    DATA_STORE_KEYS.RECAPTCHA_STATUS,
    DATA_STORE_KEYS.GRC_ACTION,
    DATA_STORE_KEYS.GRC_TOKEN,
];
